import { ButtonComponent } from '../Button'
import { FieldTextComponent } from '../FieldText'
import { FormSectionComponent } from '../FormSection'

import { useSimpleState } from '../../hooks/useSimpleState'

import './index.css'

const AffiliateFormComponent = ({ value={}, config={}, events={} }) => {
    const {_state} = useSimpleState({
        name: value.name || '',
        displayName: value.displayName || '',
        url: value.url || '',
        referralCode: value.referralCode || ''
    })

    const handleSubmit = () => {
        let body = _state.get()

        if (config.actionType === 'edit')
            body.id = value.id

        if (events.handleSubmit)
            events.handleSubmit(body)
    }

    return (
        <div className="c-AffiliateForm">
            <FormSectionComponent config={{ title: 'Affiliate Details' }}>
                <div className="form-fields">
                    <FieldTextComponent
                        value={_state.get('name')}
                        config={{ name: 'name', label: 'Name', errors: config.errors }}
                        events={{ handleChange: (val) => _state.set('name', val) }}
                    />

                    <FieldTextComponent
                        value={_state.get('displayName')}
                        config={{ name: 'displayName', label: 'Display Name', errors: config.errors }}
                        events={{ handleChange: (val) => _state.set('displayName', val) }}
                    />

                    <FieldTextComponent
                        value={_state.get('url')}
                        config={{ name: 'url', label: 'URL', errors: config.errors }}
                        events={{ handleChange: (val) => _state.set('url', val) }}
                    />

                    <FieldTextComponent
                        value={_state.get('referralCode')}
                        config={{ name: 'referralCode', label: 'Referral Code', errors: config.errors }}
                        events={{ handleChange: (val) => _state.set('referralCode', val) }}
                    />
                </div>
            </FormSectionComponent>

            <div className="form-controls">
                <ButtonComponent events={{ handleClick: handleSubmit }}>
                    {config.actionType === 'edit' ? 'Save Changes' : 'Create'}
                </ButtonComponent>
            </div>
        </div>
    )
}

export { AffiliateFormComponent }
